// src/api/invoicingApi.ts
import axios from 'axios';
import config from '../config';
import { store } from '../store/store';

/**
 * Dedicated axios instance for the owner-only invoicing screen.
 *
 * It deliberately does NOT reuse the shared `api` instance: that one dispatches `logout()` on ANY
 * 403 (see api/axiosInstance.ts), and the invoicing endpoints answer 403 for reasons that are not
 * "your session expired" — e.g. an account that is `isAdmin` in the UI but lacks the backend
 * `c_role = 'ADMIN'`, or a denied continuation of an already-authorized request. Reusing it would
 * sign the owner out of the whole site mid-sync/export. Same auth header, no logout side effect;
 * the screen handles its own errors.
 */
const invoicingApi = axios.create({
    baseURL: config.API_URL,
});

invoicingApi.interceptors.request.use(
    (requestConfig) => {
        const token = store.getState().auth.accessToken;
        if (token) {
            requestConfig.headers.Authorization = `Bearer ${token}`;
        }
        return requestConfig;
    },
    (error) => Promise.reject(error)
);

export default invoicingApi;
